import React from 'react';
import PropTypes from "prop-types";
import {connect} from "react-redux";
import Welcome from "../layout/Welcome";
import ChatRoom from "../layout/ChatRoom";
import ChatHeader from "../layout/ChatHeader";
import ChatFooter from "../layout/ChatFooter";
import styled from "styled-components";
import ChatGroupHeader from "./ChatGroupHeader";
import ChatGroupRoom from "./ChatGroupRoom";

const ChatContainer = ({selectedContact, selectedGroup}) => {
    return (
        <div>
            {!selectedContact && !selectedGroup ?
                <Welcome/>
                :
                selectedContact ?
                    <Container>
                        <ChatHeader/>
                        <ChatRoom/>
                        <ChatFooter/>
                    </Container>
                    :
                    selectedGroup ?
                        <Container>
                            <ChatGroupHeader/>
                            <ChatGroupRoom/>
                            <ChatFooter/>
                        </Container>
                        :
                        <Welcome/>
            }
        </div>
    );
}

ChatContainer.propTypes = {
    selectedContact: PropTypes.object,
    selectedGroup: PropTypes.object,
};

const mapStateToProps = (state) => ({
    selectedContact: state.contact.selectedContact,
    selectedGroup: state.contact.selectedGroup,
});

export default connect(mapStateToProps)(ChatContainer);

const Container = styled.div`
  height: 100vh;
  display: grid;
  grid-template-rows: 75px calc(100% - 150px) 75px;
  overflow: hidden;

  //@media screen and (max-width: 1000px) {
  //  position: fixed;
  //  z-index: 999;
  //}
`;